/**
 * Link to DOI. Used in multiple components
 */
export const DOI_LINK = `https://www.doi.org/`;
